/* @flow */
import { takeLatest, fork, put, call } from 'redux-saga/effects'
import { error } from 'react-notification-system-redux'
import _ from 'lodash'

import { GET_DISCOUNTS, UPDATE_COUPON_STATE, GET_ACCOUNT_COUPONS } from '../configs/constants'
import { updateCachedDiscounts, updateCachedCoupons } from '../actions/discount'
import API from '../libs/api'

const api = new API()

/* Workers */
export function* fetchDiscounts() {
  try {
    const discounts = yield call([api, api.readDBOnce], '/discounts')
    const accumulated = _.map(discounts, (discount) => {
      let accuPossibility = 0
      const contents = _.map(discount.contents, (item) => {
        accuPossibility += item.percentage
        return {
          ...item,
          accumulated: accuPossibility
        }
      })
      return {
        ...discount,
        contents,
      }
    })
    yield put(updateCachedDiscounts(accumulated))
  } catch (err) {
    yield put(error({ message: err.message }))
  }
}

export function* updateCouponStatus({ payload }) {
  try {
    yield call([api, api.writeDB], `/coupons/${payload.discountId}/${payload.coupon.code}`, {
      ...payload.coupon,
      uid: payload.uid
    })
  } catch (err) {
    yield put(error({ message: err.message }))
  }
}

export function* getAccountCoupons({ uid }) {
  try {
    const allCoupons = yield call([api, api.readDBOnce], '/coupons')
    const filtered = _.reduce(allCoupons,
      (result, event, key) => {
        result[key] = _.filter(event, (c) => c.uid === uid)
        return result
      }
    , {})
    yield put(updateCachedCoupons(filtered))
  } catch (err) {
    yield put(error({ message: err.message }))
  }
}

/* Watchers */
function* fetchDiscountsWatcher() {
  yield takeLatest(GET_DISCOUNTS, fetchDiscounts)
}
function* updateCouponStatusWatcher() {
  yield takeLatest(UPDATE_COUPON_STATE, updateCouponStatus)
}
function* getAccountCouponsWatcher() {
  yield takeLatest(GET_ACCOUNT_COUPONS, getAccountCoupons)
}

export default [
  fork(fetchDiscountsWatcher),
  fork(updateCouponStatusWatcher),
  fork(getAccountCouponsWatcher),
]


// WEBPACK FOOTER //
// ./src/sagas/discountSaga.js